import pkg from '../package.json';

const {Voonto} = window;

Voonto.ready.then((app)=>{
  Promise.all([
    Voonto.require('jquery')
  ]).then(([$]) =>{
    window.SportsData = {$};
    require('./autoload.js');

  });
});

export const VERSION = pkg.version;



// WEBPACK FOOTER //
// ./src/index.js